const relativeUnits: Array<[Intl.RelativeTimeFormatUnit, number]> = [
  ['year', 365 * 24 * 3600_000],
  ['month', 30 * 24 * 3600_000],
  ['day', 24 * 3600_000],
  ['hour', 3600_000],
  ['minute', 60_000],
  ['second', 1000],
]

const rtf = new Intl.RelativeTimeFormat('zh-CN', { numeric: 'auto' })

export function formatTs(ts?: number | null): string {
  if (!ts) return '—'
  const date = new Date(ts)
  if (Number.isNaN(date.getTime())) return '—'
  let diff = date.getTime() - Date.now()
  for (const [unit, ms] of relativeUnits) {
    if (Math.abs(diff) >= ms || unit === 'second') {
      return rtf.format(Math.round(diff / ms), unit)
    }
  }
  diff = 0
  return '刚刚'
}

export function formatAbsTs(ts?: number | null): string {
  if (!ts) return '—'
  const date = new Date(ts)
  if (Number.isNaN(date.getTime())) return '—'
  return date.toLocaleString('zh-CN', { hour12: false })
}

export function formatCoord(lat?: number | null, lon?: number | null): string {
  if (lat == null || lon == null) return '—'
  return `${lat.toFixed(3)}, ${lon.toFixed(3)}`
}

export function formatMag(mag?: number | null): string {
  if (mag == null || mag <= 0) return '—'
  return `M ${mag.toFixed(1)}`
}

export function formatLoss(loss?: string | null): string {
  if (!loss) return '—'
  return loss
}

export function formatNum(n?: number | null): string {
  if (n == null) return '—'
  return new Intl.NumberFormat('zh-CN').format(n)
}

/** 解析后端 photoUrls JSON 字符串（可能损坏），失败降级为空 */
export function parsePhotoUrls(raw?: string | null): string[] {
  if (!raw) return []
  try {
    const parsed: unknown = JSON.parse(raw)
    if (!Array.isArray(parsed)) return []
    return parsed.filter((u): u is string => typeof u === 'string' && u.length > 0)
  } catch {
    return []
  }
}

/** 后端静态资源相对路径 → /uploads/ 前缀访问 URL */
export function uploadUrl(filePath: string): string {
  return `/uploads/${filePath.replace(/^\/+/, '')}`
}
